export default __webpack_public_path__ + "static/media/portfolio.0a8c3983.png";